import { Component } from '@angular/core';
@Component({
  selector: 'irembogov-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent {}
